import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl } from 'react-intl';

import EcCheckbox from '../../Shared/EcCheckbox/EcCheckbox';
import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import styles from './SaveNFlagModal.styles';

class SaveNFlagModal extends Component {
  constructor(props) {
    super(props);

    this.handleOnSaveClick = this.handleOnSaveClick.bind(this);
    this.state = { note: '', reasons: [] };
  }

  handleOnSaveClick() {
    const { note, reasons } = this.state;
    const { handleActionClick, hideModal } = this.props;

    handleActionClick({ note, reasons });
    hideModal();
  }

  handleOnCheckboxChange(value) {
    const { reasons } = this.state;

    if (reasons.includes(value)) {
      this.setState({ reasons: reasons.filter((reason) => reason !== value) });
    } else {
      this.setState({ reasons: [...reasons, value] });
    }
  }

  render() {
    const { classes, title, hideModal, intl } = this.props;
    const { reasons } = this.state;

    return (
      <EcModalCard
        title={title}
        content={
          <div className={classes.modalBodyContent}>
            <p className={classes.modalInfo}>
              {intl.formatMessage({
                id: 'SaveNFlagModal.selectProblemsMessage',
                defaultMessage:
                  'Please select one or more problems you might have ran into while reviewing the document.',
                description:
                  'Instructions for selecting document review problems',
              })}
            </p>
            <div className={classes.reasonsContainer}>
              <div className={classes.reasonWrapper}>
                <EcCheckbox
                  checked={reasons.includes('Poor scan quality')}
                  id="SaveNFlagModal/PoorScanQualityCheckbox"
                  onClick={() =>
                    this.handleOnCheckboxChange('Poor scan quality')
                  }
                />
                <label
                  className={classes.checkboxLabel}
                  htmlFor="SaveNFlagModal/PoorScanQualityCheckbox"
                >
                  {intl.formatMessage({
                    id: 'SaveNFlagModal.poorScanQuality',
                    defaultMessage: 'Poor scan quality',
                    description: 'Checkbox label for poor scan quality issue',
                  })}
                </label>
              </div>
              <div className={classes.reasonWrapper}>
                <EcCheckbox
                  checked={reasons.includes('Foreign language')}
                  id="SaveNFlagModal/ForeignLanguageCheckbox"
                  onClick={() =>
                    this.handleOnCheckboxChange('Foreign language')
                  }
                />
                <label
                  className={classes.checkboxLabel}
                  htmlFor="SaveNFlagModal/ForeignLanguageCheckbox"
                >
                  {intl.formatMessage({
                    id: 'SaveNFlagModal.foreignLanguage',
                    defaultMessage: 'Foreign language',
                    description: 'Checkbox label for foreign language issue',
                  })}
                </label>
              </div>
              <div className={classes.reasonWrapper}>
                <EcCheckbox
                  checked={reasons.includes('Not a contract')}
                  id="SaveNFlagModal/NotAContractCheckbox"
                  onClick={() => this.handleOnCheckboxChange('Not a contract')}
                />
                <label
                  className={classes.checkboxLabel}
                  htmlFor="SaveNFlagModal/NotAContractCheckbox"
                >
                  {intl.formatMessage({
                    id: 'SaveNFlagModal.notAContract',
                    defaultMessage: 'Not a contract',
                    description: 'Checkbox label for not a contract issue',
                  })}
                </label>
              </div>
              <div className={classes.reasonWrapper}>
                <EcCheckbox
                  checked={reasons.includes(
                    'Unsure about specific data field (list data field(s) below)',
                  )}
                  id="SaveNFlagModal/UnsureAboutSpecificDataFieldCheckbox"
                  onClick={() =>
                    this.handleOnCheckboxChange(
                      'Unsure about specific data field (list data field(s) below)',
                    )
                  }
                />
                <label
                  className={classes.checkboxLabel}
                  htmlFor="SaveNFlagModal/UnsureAboutSpecificDataFieldCheckbox"
                >
                  {intl.formatMessage({
                    id: 'SaveNFlagModal.unsureAboutDataField',
                    defaultMessage:
                      'Unsure about specific data field (list data field(s) below)',
                    description:
                      'Checkbox label for uncertainty about data fields',
                  })}
                </label>
              </div>
            </div>
            <div className={classes.additionalNotesWrapper}>
              <p>
                {intl.formatMessage({
                  id: 'SaveNFlagModal.additionalNotesTitle',
                  defaultMessage: 'ADDITIONAL NOTES',
                  description: 'Title for additional notes section',
                })}
              </p>
              <textarea
                data-testid="additional-notes-textarea"
                name="additionalNotes"
                id="additionalNotesTextarea"
                cols="30"
                rows="7"
                onChange={(event) =>
                  this.setState({ note: event.target.value })
                }
              />
            </div>
          </div>
        }
        footer={
          <>
            <Button
              variant="tertiary"
              text={intl.formatMessage({
                id: 'SaveNFlagModal.cancelButton',
                defaultMessage: 'Cancel',
                description: 'Cancel button text',
              })}
              onClick={hideModal}
            />
            <Button
              variant="primary"
              text={intl.formatMessage({
                id: 'SaveNFlagModal.saveButton',
                defaultMessage: 'Save',
                description: 'Save button text',
              })}
              onClick={this.handleOnSaveClick}
            />
          </>
        }
        hideModal={hideModal}
      />
    );
  }
}

SaveNFlagModal.propTypes = {
  title: PropTypes.string.isRequired,
  handleActionClick: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default injectSheet(styles)(injectIntl(SaveNFlagModal));
